import { Link } from "react-router";
import { AppRoute } from "../../contexts/RoutesContext";

export function Breadcrumb(route: AppRoute) {
    return (
        <span key={`Breadcrumb_${route.name}`}>
            <i className="fa-solid fa-chevron-right"></i> {route.route != null ? <Link reloadDocument={route.forceReload} to={route.route}>{route.name}</Link> : <span>{route.name}</span>}
        </span>
    );
}